import React from 'react'
import styles from "../css/FloatingCards.module.css"
import { BsShieldShaded } from 'react-icons/bs'

export const SignUpFloatingCards = () => {
  return (
      <div className = {styles.wrapper}>
        <div className={`${styles.floatCard} ${styles.notePreview}`}>
            <div className={styles.npTag}>📝 Latest Note</div>
            <div className={styles.npTitle}>Meeting Notes</div>
            <div className={styles.npLines}>
                <div className={`${styles.npLine} ${styles.w90}`}></div>
                <div className={`${styles.npLine} ${styles.w80}`}></div>
                <div className={`${styles.npLine} ${styles.w65}`}></div>
            </div>
        </div>
        <div className={`${styles.floatCard} ${styles.securityCard}`}>
            <div className={styles.secIcon}>🔐</div>
            <div className={styles.secTitle}>Your notes, your rules</div>
            <div className={styles.secBody}>
                Write, update, and organize your notes with ease.  
                Protected by end‑to‑end encryption, your ideas stay private and secure — always under your control.
            </div>
        </div>
      </div>
  )
}

export const SignInFloatingCards = () => {
  return (
      <div className = {styles.wrapper}>
        <div className={`${styles.floatCard} ${styles.loginCard}`}>
            <div className={styles.secIcon}>🔑</div>
            <div className={styles.secTitle}>Sign in to your notes</div>
            <div className={styles.secBody}>
                Pick up right where you left off.  
                Your notes are always safe and ready whenever you need them.
            </div>
        </div>
        <div className={`${styles.floatCard} ${styles.welcomeCard}`}>
            <div className={styles.secIcon}>👋</div>
            <div className={styles.secTitle}>Welcome back</div>
            <div className={styles.secBody}>
                Logging in is quick and simple — so you can focus on your ideas.
            </div>
        </div>
      </div>
  )
}

export const ResetFloatingCards = () => {
    return (
      <div className = {styles.wrapper}>
        <div className={`${styles.floatCard} ${styles.optCard}`}>
            <div className={styles.otpTitle}>🔑 Verification Code</div>
            <div className={styles.otpSub}>Check your email for the 4-digit code.</div>
            <div className = {styles.otpBoxes}>
                <div className = {`${styles.otpBox} ${styles.filled}`}>2</div>
                <div className ={`${styles.otpBox} ${styles.filled}`}>7</div>
                <div className = {`${styles.otpBox} ${styles.filled}`}>4</div>
                <div className = {`${styles.otpBox} ${styles.cursor}`}>_</div>
            </div>
        </div>
        <div className={`${styles.floatCard} ${styles.securityCard}`}>
            <div className={styles.secIcon}><BsShieldShaded/></div>
            <div className={styles.secTitle}>Account Security</div>
            <div className={styles.secBody}>
                After resetting, all active sessions will be signed out to keep your notes safe
            </div>
        </div>
      </div>
    )
}